import * as React from 'react';
import * as Images from 'pos/Images';
import { OnlineReservationInListDTO, Permission, Res } from 'core/api';
import { HStack, Text, VStack, Link } from '@chakra-ui/react';
import { DialogBody, DialogFooter, SvgIcon } from 'core/ui-next/chakra-components';
import { BasicButton } from 'core/ui-next';
import { Modal } from 'core/ui-next/modal';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { ThemeManager } from 'pos/ui';

type AttendReservationResult = { attendAtOtherLocation: boolean }

type Props = {
	reservation: OnlineReservationInListDTO;
	allowAttendAtOtherLocation: boolean;
} & Modal.Actions<AttendReservationResult>;


export function AttendReservationDialog(props: Props) {

	const { close, cancel, reservation, allowAttendAtOtherLocation } = props;

	// Si la reserva no tiene ubicación, hay que atenderla en otra disponible
	const onAccept = React.useCallback(async () => close({ attendAtOtherLocation: false }), [close]);
	const onCancel = React.useCallback(async () => cancel(), [cancel]);
	const onAttendInOtherLocation = React.useCallback(async () => close({ attendAtOtherLocation: true }), [close]);

	const locationText = allowAttendAtOtherLocation ? Res.Web.SELECT_ONLINE_RESERVATION_LOCATION_LBL(reservation.Location) + ' - ' : '';
	const timeText = Res.Web.SELECT_ONLINE_RESERVATION_HOUR_LBL(reservation.StartTime);

	return (
		<VStack paddingY={ThemeManager.isPhone() ? '6' : '9'} paddingX={ThemeManager.isPhone() ? '6' : '12'} gap={'6'} bg={{ base: 'white', _dark: '{colors.neutral.900}' }}>
			<DialogBody p={'0'}>
				<VStack justifyContent='center' gap={'2'} textAlign={'center'}>
					<SvgIcon src={Images.OnlineReservation} w={ThemeManager.isPhone() ? '9' : '12'} h={ThemeManager.isPhone() ? '9' : '12'} />
					<VStack gap={'2'}>
						<Text fontSize={'md'} fontWeight={'bold'}>{reservation.Customer}</Text>
						<Text>
							{`${locationText}${timeText}`}
						</Text>
					</VStack>
					<Text fontSize={'md'} fontWeight={'normal'}>{Res.Web.SELECT_ONLINE_RESERVATION_SERVE_RESERVATION_WITHOUT_LOCATION_LBL()}</Text>
				</VStack>
			</DialogBody>
			<DialogFooter justifyContent='center' p={'0'}>
				<VStack gap='6'>
					<HStack gap='9'>
						<BasicButton w={ThemeManager.isPhone() ? '30' : '36'} type={'secondary'} text={Res.Common.CANCEL_BTN()} onClick={onCancel} />
						<BasicButton w={ThemeManager.isPhone() ? '30' : '36'} type={'success'} text={Res.Common.OK_BTN()} onClick={onAccept} />
					</HStack>
					{allowAttendAtOtherLocation && (<Link variant='plain' color='info' onClick={onAttendInOtherLocation}>{Res.Web.SELECT_ONLINE_RESERVATION_ATTEND_ON_OTHER_LOCATION_LBL()}</Link>)}
				</VStack>
			</DialogFooter>
		</VStack>
	);
}

declare global {
	interface CommandType {
		confirmAttendOnlineReservation: (reservation: OnlineReservationInListDTO, allowAttendAtOtherLocation: boolean) => Promise<Result<AttendReservationResult>>
	}
}

Command.register('confirmAttendOnlineReservation', Preconditions.and(Preconditions.ensure(Permission.OnlineReservation_Attend), Preconditions.ensureIsNotLite), async (reservation: OnlineReservationInListDTO, allowAttendAtOtherLocation: boolean): Promise<Result<AttendReservationResult>> => {
	return Modal.show(AttendReservationDialog, { reservation, allowAttendAtOtherLocation, placement: 'center', size: 'md' });
});
